<template>
  <van-popup v-model="show" round position="bottom">
    <van-datetime-picker
      title="请选择年月日"
      :value="date"
      type="date"
      @cancel="show = false"
      @confirm="handleConfirm"
    />
  </van-popup>
</template>

<script>
import dayJS from 'dayjs'
export default {
  name: 'DatePicker',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentDate: {
      type: String,
      required: true
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    date() {
      return dayJS(this.currentDate).toDate()
    }
  },
  methods: {
    handleConfirm(val) {
      const date = dayJS(val).format('YYYY-MM-DD')
      this.show = false
      this.$emit('changeDate', date)
    }
  }
}
</script>

<style lang="less" scoped>

</style>